import Vue from 'vue';
import VueRouter from 'vue-router';

// import Sm from '@/view/sm';
import Sm from '@/view/sm/index-new.vue';
import WebRtc from '@/view/web-rtc';
import PicPx from '@/view/pic/PicPx.vue';
import GoView from '@/view/go-view/go-index.vue';
import AgentCollect from '@/view/agent/collect.vue';
import IphonLocal from '@/view/iphon-local/index.vue';
import IphonLocalAuth from '@/view/iphon-local/auth.vue';
import IphonLocalMap from '@/view/iphon-local/map.vue';
import IphonLocalTutorial from '@/view/iphon-local/tutorial.vue';
import IphonLocalCoordinateGuide from '@/view/iphon-local/coordinate-guide.vue';
import FnSm from '@/view/fn/fn-sm';
import { getCardSession } from '@/view/iphon-local/card-session';
import { verifyVpnConnection, vpnAccessErrorMessage } from '@/view/iphon-local/vpn-access';
import { Toast } from 'vant';

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: '/',
      component: Sm,
      meta: { show: true },
    },
    {
      path: '/web-rtc',
      component: WebRtc,
      meta: { show: true },
    },
    {
      path: '/fn-sm',
      component: FnSm,
      meta: { show: true },
    },
    {
      path: '/mt-room/:keyScrent',
      component: GoView,
      meta: { show: true },
    },
    {
      path: '/pic',
      component: PicPx,
      meta: { show: true },
    },
    {
      path: '/agent-collect',
      component: AgentCollect,
      meta: { show: true },
    },
    {
      path: '/iphon-seting/auth',
      component: IphonLocalAuth,
      meta: { show: true },
    },
    {
      path: '/iphon-seting',
      component: IphonLocal,
      meta: { show: true, requiresCardAuth: true },
    },
    {
      path: '/iphon-seting/map',
      component: IphonLocalMap,
      meta: { show: true, requiresCardAuth: true },
    },
    {
      path: '/iphon-seting/tutorial',
      component: IphonLocalTutorial,
      meta: { show: true },
    },
    {
      path: '/iphon-seting/coordinate-guide',
      component: IphonLocalCoordinateGuide,
      meta: { show: true },
    },
    {
      path: '/px',
      redirect: '/pic',
    },
    {
      path: '/:keyScrent',
      component: Sm,
      meta: { show: true },
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  // 开发环境直接放行需要卡密的页面，方便联调；生产构建仍执行完整卡密校验。
  const localPreview = process.env.NODE_ENV === 'development';
  if (to.path === '/' && !to.query.keyScrent) {
    next({
      path: '/iphon-seting',
    });
    return;
  }

  if (!localPreview && to.matched.some(route => route.meta && route.meta.requiresCardAuth)) {
    if (!getCardSession()) {
      next({
        path: '/iphon-seting/auth',
        query: {
          redirect: to.fullPath,
        },
      });
      return;
    }
  }

  // 地图页必须存在真实的 strongSwan 在线会话，不能仅凭本地卡密会话直接进入。
  if (to.path === '/iphon-seting/map') {
    const session = getCardSession();
    if (!session) {
      next({ path: '/iphon-seting/auth', query: { redirect: to.fullPath } });
      return;
    }
    try {
      await verifyVpnConnection(session);
    } catch (error) {
      Toast.fail(vpnAccessErrorMessage(error));
      next({ path: '/iphon-seting', query: { vpnRequired: '1' } });
      return;
    }
  }
  next();
});

export default router;
